import React from 'react';
import Radium from 'radium';
import { UTLabel } from '@widergy/energy-ui';

import { billProgressPropTypes } from 'types/billTypes';
import UTTag from 'app/components/UTTag';
import { appConfig } from 'config/customization';
import { message } from 'utils/stringUtils';

import icConsumoSmilePng from '../../assets/ic_consumo_smile.png';
import icEnergyAdvisor from '../../assets/ic_energy_advisor.png';

import HelpButton from './components/HelpButton';
import LabeledIcon from './components/LabeledIcon';
import styles from './styles';

function AnualProgress({ progress }) {
  return (
    <div style={styles.container}>
      <div style={styles.titleContainer}>
        <UTLabel semibold style={styles.titleProgress}>
          {message('AccountStatus:yourAnualProgress')}
        </UTLabel>
        <HelpButton />
      </div>
      <div style={styles.consumptions}>
        <UTTag style={styles.tag}>{progress.lastYearAccumulated}</UTTag>
        <UTTag green style={styles.tag}>
          {progress.currentYearAccumulated}
        </UTTag>
      </div>
      {progress.existsLastYearConsumption && (
        <div style={styles.icons}>
          <LabeledIcon plug>{progress.consumptionDifference}</LabeledIcon>
          {appConfig.showAmountComparison && <LabeledIcon saving>{progress.moneySaving}</LabeledIcon>}
          <LabeledIcon co2>{progress.carbonImpact}</LabeledIcon>
        </div>
      )}
      <div style={styles.positiveConsumption}>
        <div style={styles.happyImg}>
          <img
            src={progress.percentageSaved > 0 ? icConsumoSmilePng : icEnergyAdvisor}
            alt="happy"
            style={styles.happyImg}
          />
        </div>
        <UTLabel small style={styles.congratulationText}>
          {progress.existsLastYearConsumption
            ? progress.percentageSaved > 0
              ? message('AccountStatus:efficientMessage', {
                  saving: Math.abs(progress.percentageSaved)
                })
              : message('AccountStatus:noEfficientMessage', {
                  saving: Math.abs(progress.percentageSaved)
                })
            : message('AccountStatus:noConsumptionMessage')}
        </UTLabel>
      </div>
    </div>
  );
}

AnualProgress.propTypes = {
  progress: billProgressPropTypes
};

export default Radium(AnualProgress);
